import { Component, input, CUSTOM_ELEMENTS_SCHEMA, signal, effect, inject } from '@angular/core';
import { ResultsService } from '../../../services/results.service';

@Component({
  selector: 'app-property-gallery',
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './property-gallery.html',
})
export class PropertyGallery {
  private resultsService = inject(ResultsService);

  public readonly index = input.required<number>();
  public readonly photos = input.required<string[]>();

  public readonly validPhotos = signal<string[]>([]);

  constructor() {
    // Initialize validPhotos when photos input changes
    effect(() => {
      this.validPhotos.set([...this.photos()]);
    });
  }

  public onImageError(photo: string): void {
    // Remove the failed photo
    this.validPhotos.update((photos) => photos.filter((p) => p !== photo));

    // Notify parent if no photos left
    if (this.validPhotos().length === 0) {
      this.resultsService.removeResult(this.index());
    }
  }
}
